/** Skripsi-team live queries. */

import { COL } from '../../collections';
import { where, orderBy } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { SkripsiTeamDoc } from '../../types';

export function useSkripsiTeam(skripsiId: string | null) {
  return useLiveQuery<SkripsiTeamDoc>(
    skripsiId ? COL.skripsiTeam : null,
    skripsiId ? [where('skripsiId', '==', skripsiId), orderBy('assignedAt', 'asc')] : [],
    Boolean(skripsiId),
  );
}

/** All skripsi-team assignments (for prodi-wide scoping & verification). */
export function useAllTeam() {
  return useLiveQuery<SkripsiTeamDoc>(COL.skripsiTeam, [orderBy('assignedAt', 'asc')]);
}

export function useActiveTeamMembers(skripsiId: string | null, role: string) {
  const { data, loading, error } = useSkripsiTeam(skripsiId);
  const active = data.filter((t) => t.status === 'active' && t.role === role);
  return { data: active, loading, error };
}
